module.exports = __webpack_public_path__ + "bb585889383b2ea7fd17700e2fb80d64.svg";